













import { Vue, Component } from "@/shared/vuepack";
import HsaBankOnboardingFooter from "@/employee/components/shared/HsaBankOnboardingFooter.vue";

@Component({
  components: {
    HsaBankOnboardingFooter
  }
})
export default class UpfrontContributionBase extends Vue { }
